export const aiKeys = {
  all: ["ai"] as const,
  image: ["ai", "image"] as const,
  mediaPromptSuggestions: (content: string, type: string) =>
    ["ai", "media-prompt-suggestions", content, type] as const,
  limitations: (type: "image" | "text" | "translation") =>
    ["ai", "limitations", type] as const,
};
